import axios from "axios";
import {
  addDirectorySuccess,
  addDirectoryFail,
  getDirectorySuccess,
  getDirectoryFail,
  getDepartmentsSuccess,
  getDepartmentsFail,
  updateSingleDirectorySuccess,
  updateSingleDirectoryFail,
  deleteSingleDirectorySuccess,
  deleteSingleDirectoryFail,
  addBulkDirectorySuccess,
  addBulkDirectoryFail,
  directoryBulkDataReportClear
} from "../constant";
import { Api } from "../../Config/config.js";
import { store } from "../store";

export const addDirectory = async (dispatch, body) => {
  try {
    const response = await axios.post(`${Api}Directory`, body, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });

    dispatch({
      type: addDirectorySuccess,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: addDirectoryFail,
      payload: error.response.data,
    });
  }
};

export const addBulkDirectory = async (dispatch, data, accountID, onProgress) => {

  try {
    const response = await axios.post(`${Api}Directory/bulkDirectoryUpload/${accountID}`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
            "Bearer " + store.getState().authReducer.tokens.access.token,
      },
      onUploadProgress: onProgress,
    });

    dispatch({
      type: addBulkDirectorySuccess,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: addBulkDirectoryFail,
      payload: error.response.data,
    });
  }
};

export const bulkDirectoryDataReportClear = async (dispatch) => {
  dispatch({
    type: directoryBulkDataReportClear,
    payload: null,
  });

};

export const getDirectory = async (
  dispatch,
  accountID,
  selectedDepartment,
  limit,
  Page,
) => {
  try {
    const params = {
      accountID: accountID,
      sortBy: "-createdAt",
      limit: limit,
      page: Page,
    };

    if (selectedDepartment !== "All") {
      params.department = selectedDepartment;
    }
    const response = await axios.get(`${Api}Directory`, {
      params: params,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });
    dispatch({
      type: getDirectorySuccess,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: getDirectoryFail,
      payload: error.response.data,
    });
  }
};

export const getDepartments = async (dispatch, accountID) => {
  try {
    const response = await axios.get(`${Api}Directory/departments`, {
      params: {
        accountID: accountID,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });
    dispatch({
      type: getDepartmentsSuccess,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: getDepartmentsFail,
      payload: error.response.data,
    });
  }
};

export const updateSingleDirectoryData = async (dispatch, id, body) => {
  try {
    const response = await axios.put(`${Api}Directory/contact/${id}`, body, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });

    dispatch({
      type: updateSingleDirectorySuccess,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: updateSingleDirectoryFail,
      payload: error.response.data,
    });
  }
};

export const deleteSingleDirectoryData = async (dispatch, id) => {
  try {
    const response = await axios.delete(`${Api}Directory/contact/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });

    dispatch({
      type: deleteSingleDirectorySuccess,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: deleteSingleDirectoryFail,
      payload: error.response.data,
    });
  }
};
